import React, { useContext, useEffect, useState } from "react";
import "./RoadStatement.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { LanguageContext } from "../../context/LanguageContext";
import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const RoadStatement = () => {
  const { currentLang } = useContext(LanguageContext);
  const [section, setSection] = useState(null);
  const [loading, setLoading] = useState(true);

  const isRTL = currentLang === "ar" || currentLang === "ku";

  const resolveUrl = (url) => {
    if (!url) return "";
    return url.startsWith("http") ? url : `${API_BASE}${url}`;
  };

  useEffect(() => {
    const fetchSection = async () => {
      try {
        setLoading(true);
        const res = await axios.get(
          `${API_BASE}/api/RoadStatementSection?lang=${currentLang}`
        );
        setSection(res.data);
      } catch (err) {
        console.error("Error fetching RoadStatement section:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchSection();
  }, [currentLang]);

  if (loading) return <div className="roadStatement-loading">Loading...</div>;
  if (!section) return <div className="roadStatement-error">No data found.</div>;

  return (
    <div
      className={`roadStatement ${isRTL ? "rtl" : ""}`}
      dir={isRTL ? "rtl" : "ltr"}
    >
      <div className="roadStatementText">
        <h1>{section.title}</h1>
        <p>{section.description}</p>
      </div>

      <div className="roadStatement-slider">
        <Swiper
          modules={[Pagination, Navigation]}
          pagination={{ clickable: true }}
          navigation
          spaceBetween={50}
          slidesPerView={1}
          loop
          dir={isRTL ? "rtl" : "ltr"}
        >
          {section.slides.map((slide, index) => {
            const leftImage = resolveUrl(slide.imageLeftUrl);
            const rightImage = resolveUrl(slide.imageRightUrl);

            return (
              <SwiperSlide key={index}>
                <div className="roadStatement-slide">
                  {isRTL ? (
                    <>
                      {/* Right Image first for RTL */}
                      <div className="roadStatement-right">
                        <div className="roadStatement-imgBox">
                          <img src={rightImage} alt={`slide-${index}-right`} />
                        </div>
                      </div>

                      {/* Left content */}
                      <div className="roadStatement-left">
                        <div className="roadStatement-imgBox">
                          <img src={leftImage} alt={`slide-${index}-left`} />
                        </div>
                        <div className="roadStatement-content">
                          <h2>{slide.title}</h2>
                          <p>{slide.description}</p>
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      {/* LTR Content first */}
                      <div className="roadStatement-left">
                        <div className="roadStatement-imgBox">
                          <img src={leftImage} alt={`slide-${index}-left`} />
                        </div>
                        <div className="roadStatement-content">
                          <h2>{slide.title}</h2>
                          <p>{slide.description}</p>
                        </div>
                      </div>

                      {/* Right Image */}
                      <div className="roadStatement-right">
                        <div className="roadStatement-imgBox">
                          <img src={rightImage} alt={`slide-${index}-right`} />
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </div>
  );
};

export default RoadStatement;
